export const videoWrapperStyles = {
	borderRadius: '0.5rem',
};

export const getImageWrapperStyles = (shouldDisplayMediaFirst: boolean) => ({
	display: 'flex',
	justifyContent: shouldDisplayMediaFirst ? 'flex-end' : 'flex-start',
});
